import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import VenuesApprovalRequests from "./VenuesApprovalRequests";
import Table from "../../../Layout/Table/Table";
import NavBar from "../../../../components/NavBarAdmin";

const VenuesApproval = () => {



    const ActionColumn = ({ id }) => {
        return (
            <div>
                <Link to={`/my/admin/venues-approval/${id}`} className="btn btn-secondary btn-sm"><i className="fa-solid fa-eye"></i>&nbsp; View</Link>
            </div>
        )
    }

    const columns = ['', 'name', 'date_create', 'date_update', 'Actions'];

    const serializeRowsColums = () => {
        return data.map((item) => {
            // let obj = item;
            // obj["status"] = <StatusColumn status={obj.status} />;
            // obj["Actions"] = <ActionColumn id={obj.id} />;
            return {
                ...item,
                Actions: <ActionColumn id={item.id} />,
            };
        })
    }

    const [data, setData] = useState([])
    useEffect(async () => {
        let info = await VenuesApprovalRequests.getVenuesApprovalList();
        if (info && info.status) {
            setData(info.data)
        }
    }, [])


    return (
        <div>
            <NavBar>
                <div className="row">
                    <div className="col-xs-12 dashboard-content">
                        <div className="row">
                            <div className="col-8">
                                <h2 className="dashboard-h2"> Venues List</h2>
                            </div>

                        </div>
                        <div className="row">
                            <div className="col-12 event-list-table" >
                                <Table
                                    columns={columns}
                                    data={serializeRowsColums(data)}
                                    currentPage={1}
                                    itemsPerPage={10}
                                    totalItems={data.length}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </NavBar>
        </div>
    )
}


export default VenuesApproval;